// extracted by mini-css-extract-plugin
module.exports = {"container":"member-operations__MultiLineText__container","line":"member-operations__MultiLineText__line"};